import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { Button, IconButtonProps, Tooltip, Typography } from '@mui/material';
import { AssistanceResponseFeedbackModalContent } from '../AssistanceResponseFeedbackModalContent/AssistanceResponseFeedbackModalContent';

export interface AssistanceResponseThumbDownButtonProps
  extends IconButtonProps {
  responseID: string;
  onFeedbackSubmit: (
    comments: string,
    selectedOptions: string[],
  ) => Promise<void>;
  userFeedbackOptions?: string[];
  onClick?: () => void;
}

export function AssistanceResponseNoButton({
  responseID,
  disabled,
  onFeedbackSubmit,
  userFeedbackOptions,
  onClick,
  ...iconButtonProps
}: AssistanceResponseThumbDownButtonProps) {
  const { openModal } = useMuiModalContext();

  const openFeedbackModal = () => {
    openModal({
      contentComponent: () => (
        <AssistanceResponseFeedbackModalContent
          onFeedbackSubmit={onFeedbackSubmit}
          userFeedbackOptions={userFeedbackOptions}
        />
      ),
      modalProps: {
        PaperProps: {
          elevation: 3,
        },
        fullWidth: true,
      },
    });
  };

  return (
    <Tooltip title="Dislike" disableInteractive>
      <Button
        disabled={disabled}
        variant={disabled ? 'contained' : 'outlined'}
        sx={{
          px: 0.5,
          py: 0.1,
          minHeight: 0,
          minWidth: 0,
          ...iconButtonProps.sx,
          textTransform: 'none',
        }}
        onClick={(e) => {
          e.stopPropagation();
          openFeedbackModal();
          onClick?.();
        }}
      >
        <Typography color="inherit" variant="caption">
          No
        </Typography>
      </Button>
    </Tooltip>
  );
}
